<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="media-checking">
      <div class="filter-search">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="统计日期：">
            <el-date-picker size="small" v-model="searchData.applyTime" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="广告名称：">
            <el-input size="small" v-model="searchData.AdName" clearable placeholder="请输入广告名称"></el-input>
          </el-form-item>
          <el-form-item label="计划ID：">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model="searchData.PutOnId" clearable placeholder="请输入计划ID"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getExternalMiningList(1)">查询</el-button>
            <a class="export-button" :href="exportUrl" target="_blank">导出</a>
            <div class="import-button">
              <el-button type="primary" size="small">
                导入
              </el-button>
              <input type="file" ref="uploadFile" @change="previewImportData" class="import-file">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-type">
        <span class="el-icon-menu data-size">外采数据（{{dataSize}}条）</span>
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
          <el-table-column align="center" prop="StatisDate" label="日期" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="AdType" label="广告类型" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="PutOnId" label="计划ID" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="AdName" label="广告名称" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="Magnitude" label="量级" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="EffectDescription" label="效果说明" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip :formatter="formatMoney" prop="PrePrice" label="预单价" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="Link" label="链接" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="System" label="系统" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SettlementMagnitude" label="结算量级" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip :formatter="formatMoney" prop="SettlementMoney" label="结算金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourcemanName" label="渠道负责人" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceComany" label="渠道公司名称" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceSign" label="渠道签约主体" min-width="130">
          </el-table-column>
        </el-table>
        <!-- 分页显示 -->
        <el-pagination background layout="prev, pager, next" :total="dataSize" :page-size="20" :current-page="currentPage" @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 格式化导入数据时间
Date.prototype.Format = function(fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// 工具函数
import { formatDate, formatDateymd } from "common/js/common";
import XLSX from "xlsx";
// api
import {
  ExternalMiningList,
  ImportExternalMiningList
} from "api/dataManagement";

export default {
  data() {
    return {
      searchData: {
        // 计划ID
        PutOnId: "",
        // 广告名称
        AdName: "",
        // 统计日期
        applyTime: []
      },
      // 面包屑参数
      trails: [
        {
          trail: "数据管理",
          href: ""
        },
        {
          trail: "外采数据",
          href: ""
        }
      ],
      // 数据总数
      dataSize: 0,
      // 当前页
      currentPage: 1,
      // 表格数据
      tableData: []
    };
  },
  computed: {
    // 导出路径
    exportUrl() {
      var filterData = {
        PutOnId: this.searchData.PutOnId,
        AdName: this.searchData.AdName,
        StatisDateBegin: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        StatisDateEnd: this.searchData.applyTime
          ? this.searchData.applyTime[1]
          : ""
      };
      var url = `/IAD_ExternalMining/ExportExternalMiningList?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    }
  },
  components: {
    // 面包屑
    crumbs
  },
  methods: {
    // 设置统计时间 默认为当前日期前一个月
    initDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.searchData.applyTime.push(formatDate(start));
      this.searchData.applyTime.push(formatDate(end));
    },
    // 获取媒体提现申请数据
    getExternalMiningList(type) {
      if (type) {
        this.currentPage = 1;
      }
      var filterData = {
        PageNumber: this.currentPage,
        PutOnId: this.searchData.PutOnId,
        AdName: this.searchData.AdName,
        StatisDateBegin: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        StatisDateEnd: this.searchData.applyTime
          ? this.searchData.applyTime[1]
          : ""
      };
      ExternalMiningList(filterData)
        .then(res => {
          if (res.data) {
            this.tableData = res.data;
            this.dataSize = res.totalNum;
          } else {
            this.tableData = [];
            this.dataSize = 0;
          }
        })
        .catch(err => {
          this.tableData = [];
          this.dataSize = 0;
        });
    },
    // 导入外采数据
    previewImportData(e) {
      var that = this;
      var f = e.target.files[0];
      if (f) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result;
          var wb = XLSX.read(data, {
            type: "binary"
          });
          var jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);

          jsonData.forEach(ele => {
            ele["日期"] = new Date(1900, 0, ele["日期"] - 1).Format(
              "yyyy-MM-dd"
            );
          });
          if (jsonData.length > 200) {
            that.$notify.warning({
              title: "警告",
              message: "导入数据条数不能超过200条",
              showClose: false,
              duration: 2000
            });

            that.$refs.uploadFile.value = "";
          } else {
            that.ImportMediaDrawData(jsonData);
          }
        };
        reader.readAsBinaryString(f);
      }
    },
    // 导入外采数据接口处理
    ImportMediaDrawData(data) {
      var that = this;
      var uploadDataTemplate = {
        StatisDate: "日期",
        AdType: "广告类型",
        PutOnId: "计划ID",
        AdName: "广告名称",
        Magnitude: "量级",
        EffectDescription: "效果说明",
        PrePrice: "预单价",
        Link: "链接",
        System: "系统",
        SettlementMagnitude: "结算量级",
        SettlementMoney: "结算金额",
        SourcemanName: "渠道负责人",
        SourceComany: "渠道公司名称",
        SourceSign: "渠道签约主体"
      };

      if (data) {
        var uploadData = this.formatUploadData(data, uploadDataTemplate);
        ImportExternalMiningList(uploadData)
          .then(res => {
            that.$notify.success({
              title: "提示",
              message: res.Remark,
              dangerouslyUseHTMLString: true,
              showClose: false,
              duration: 2500
            });
            this.getExternalMiningList();
            this.$refs.uploadFile.value = "";
          })
          .catch(code => {
            // that.$notify.error({
            //   title: "错误",
            //   message:  res.Remark,
            //   showClose: false,
            //   duration: 3000
            // });
            this.$refs.uploadFile.value = "";
          });
      } else {
        this.$refs.uploadFile.value = "";
      }
    },
    //格式化导入数据
    formatUploadData(data, uploadDataTemplate) {
      var uploadData = [];
      data.forEach(function(ele) {
        var tempObj = {};
        for (var key in ele) {
          for (var key2 in uploadDataTemplate) {
            if (key === uploadDataTemplate[key2]) {
              tempObj[key2] = ele[key];
            }
          }
        }
        uploadData.push(tempObj);
      });
      return uploadData;
    },
    // 格式化金额
    formatMoney(row, column, cellValue, index) {
      if (cellValue > 0) {
        return `￥${cellValue}`;
      } else {
        return cellValue;
      }
    },
    // 分页切换页码
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.getExternalMiningList();
    }
  },
  created() {
    document.title = "外采数据";
    this.initDate();
    this.getExternalMiningList();
  },
  mounted() {}
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss" scoped>
@import "../../common/scss/color.scss";
.media-checking {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-date-editor {
      width: 250px;
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin-left: 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
    .import-button {
      margin-left: 10px;
      display: inline-block;
      position: relative;
      .import-file {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      font-size: 14px;
      color: #bbbbbb;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-table {
      th {
        background-color: #f5f5f5;
        color: #101010;
      }
    }
    .el-button {
      margin: 0;
      width: 100%;
      font-size: 14px;
    }
    .el-pagination {
      text-align: center;
      margin: 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/data-management/external-mining-data.vue